<template>
  <div class="stats">
    <StatCard
      v-for="card in visibleStatCards"
      :key="card.label"
      v-bind="card.props"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import StatCard from './StatCard.vue';
import { getStatCards } from '@/entities/statCards';

const store = useGameStore();

const visibleStatCards = computed(() => getStatCards().filter(card => card.isStatVisible(store.state)));
</script>

<style scoped>
.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #444;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
}

.stat-value {
  font-size: 1.5em;
  font-weight: bold;
  color: #00ff88;
  margin-top: 5px;
}

.storage-info {
  font-size: 0.8em;
  color: #888;
  margin-top: 5px;
}

.failure-rate {
  font-size: 0.8em;
  color: #ffaa00;
  margin-top: 5px;
}

.progress-bar {
  width: 100%;
  height: 20px;
  background: #333;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px 0;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #00ff88, #00cc6a);
  transition: width 0.3s ease;
}

@media (max-width: 768px) {
  .stats {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style> 